import { useMutation } from 'react-query';
import { useModal } from 'store/modals';
import { sendPinForPairingAPI } from './api';

export function useSendPinForPairing(user) {

  const { openModal } = useModal();
  const { mutateAsync, mutate, isLoading, isSuccess, isError } = useMutation(
    () => sendPinForPairingAPI(user),
    {
      onSuccess: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'codeSentToUserEmail',
          },
        });
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      },
    },
  );

  return {
    mutateAsync,
    mutate,
    isLoading,
    isSuccess,
    isError,
  };
}

